import { useMaybeAssignCategoryTreeExperiment } from "@faire/deprecated-retailer-visitor-shared/lib/useMaybeAssignCategoryTreeExperiment";
import { useSearchPageSelectedCategoryFiltersArray } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageSelectedCategoryFiltersArray";
import { IRecordCategoryNodesVisibilityRequest } from "@faire/web-api--source/indigofair/category/IRecordCategoryNodesVisibilityRequest";
import { useEffect } from "react";

export const useSearchPageMaybeAssignCategoryTreeExperiment = () => {
  const selectedCategoryFiltersArray =
    useSearchPageSelectedCategoryFiltersArray();
  const maybeAssignCategoryTreeExperiment =
    useMaybeAssignCategoryTreeExperiment();

  /**
   * Assigning to the category tree experiment for the case where a user navigates
   * to the search with a category filter applied, but the category filter isn't visible.
   * Cases include a direct load from the URL on mobile web, or navigation to the search
   * page when the filters bar is hidden.
   */
  useEffect(() => {
    maybeAssignCategoryTreeExperiment(
      () =>
        selectedCategoryFiltersArray.map(
          (categoryFilterOption) => categoryFilterOption.key
        ),
      IRecordCategoryNodesVisibilityRequest.Source.APP_SEARCH_RESULTS
    );
  }, [selectedCategoryFiltersArray, maybeAssignCategoryTreeExperiment]);
};
